// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"aef660f7","142":"f9535c8a","162":"7d576640"}[chunkId] + ".chunk.js";
};